import React  from 'react';

import PersonalInformationContent from "../content/PersonalInformationContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

function PersonalInformation() {
    return(
        <>
        <Navbar />
        <PersonalInformationContent/>
        <Footer />        
        </>
    );
}

export default PersonalInformation;